// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"173":"dddcec86","287":"39ba3a8e","586":"cc99675e","916":"405eac92","919":"4a14a093"}[chunkId] + ".chunk.css";
};